import { render } from "./DiscountRecordModal.vue?vue&type=template&id=829e3d88&ts=true"
import script from "./DiscountRecordModal.vue?vue&type=script&lang=ts"
export * from "./DiscountRecordModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__